<template>
  <div class="row pb-5 accordion-element">
    <div class="col">
      <Accordion>
        <AccordionTab header="Détails">
          <div class="row">
            <div class="col-5">
              <div class="row">
                  <div class="col-7 lbl"><label>Numéro Cardex :</label></div>
                  <div class="col-5 txt">
                      <p v-if="!numeroCardex"> ... </p>
                      <p v-else> {{numeroCardex}} </p>
                  </div>
              </div>
              <div class="row">
                <div class="col-7 lbl"><label>Date de approbation :</label></div>
                <div class="col-5 txt">
                  <p v-if="!approuveLe"> ... </p>
                  <p v-else> {{approuveLe}} </p>
                </div>
              </div>
              <div class="row">
                <div class="col-7 lbl"><label>Date de création :</label></div>
                <div class="col-5 txt">
                  <p v-if="!creerLe"> ... </p>
                  <p v-else> {{creerLe}} </p>
                </div>
              </div>
              <div class="row">
                <div class="col-7 lbl"><label>Date de modification :</label></div>
                <div class="col-5 txt">
                  <p v-if="!modifieLe"> ... </p>
                  <p v-else> {{modifieLe}} </p>
                </div>
              </div>
            </div>
            <div class="col-7">
              <div class="row">
                  <div class="col-7 lbl"><label></label></div>
                  <div class="col-5 txt">
                  </div>
              </div>
              <div class="row">
                <div class="col-7 lbl"><label>Approuvé par :</label></div>
                <div class="col-5 txt">
                  <p v-if="!narrationLocal.approuveParDescription"> ... </p>
                  <p v-else> {{ narrationLocal.approuveParDescription }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col-7 lbl"><label>Créé par :</label></div>
                <div class="col-5 txt">
                  <p v-if="!narrationLocal.creerParDescription"> ... </p>
                  <p v-else> {{ narrationLocal.creerParDescription }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col-7 lbl"><label>Modifié par :</label></div>
                <div class="col-5 txt">
                  <p v-if="!narrationLocal.modifieParDescription"> ... </p>
                  <p v-else> {{ narrationLocal.modifieParDescription }} </p>
                </div>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    </div>
  </div>
</template>

<script>
export default {
  name: "Information",
  props: ['approuveLe', 'creerLe', 'modifieLe', 'narrationLocal', 'numeroCardex'],
}
</script>